<script lang="ts">
	import { fade, fly, draw } from "svelte/transition";
	// import { quintOut } from 'svelte/easing';
//	import { yyyy, zzzz } from "./stores";

	let {usage, interact}: {usage: string; interact: boolean} = $props()



	//#ff3e00
	let logoSide: string = "left";

	let toggle = () => {
		//console.log("toggling");
		if (interact) {
			//console.log("toggling");
			if (usage === "logo") {
				return (usage = "wait");
			}
			if (usage === "wait") {
				return (usage = "logo");
			}
		}
	};
</script>

<div
	role="banner"
	ondblclick={toggle}
	transition:fly|local
	id={usage}
	class={logoSide}
>
	<svg
		version="1.1"
		viewBox="0.0 0.0 390.8582677165354 114.86876640419948"
		fill="none"
		stroke="none"
		stroke-linecap="square"
		stroke-miterlimit="10"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
	>
		<clipPath id="p.0">
			<path
				d="m0 0l390.85828 0l0 114.86877l-390.85828 0l0 -114.86877z"
				clip-rule="nonzero"
			/>
		</clipPath>
		<g clip-path="url(#p.0)">
			{#if usage === "logo" || usage === "side" || usage === "centre"}
				<path
					transition:fly|local={{ x: 200 }}
					fill="RGB(51,51,51)"
					fill-opacity="0.0"
					d="m0 0l390.85828 0l0 114.86877l-390.85828 0z"
					fill-rule="nonzero"
				/>
				<path
					transition:fly|local
					fill="RGB(51,51,51)"
					fill-opacity="0.0"
					d="m0 12.199475l417.00787 0l0 108.97637l-417.00787 0z"
					fill-rule="nonzero"
				/>
				<path
					transition:fade|local
					fill="RGB(51,51,51)"
					d="m51.6875 78.79573q0.328125 0.765625 0.328125 1.28125q0 1.21875 -0.8125 2.046875q-0.796875 0.828125 -2.078125 0.828125q-0.890625 0 -1.625 -0.46875q-0.734375 -0.484375 -1.125 -1.3125l-4.15625 -9.984375l-21.765625 0l-4.15625 9.984375q-0.390625 0.828125 -1.125 1.3125q-0.734375 0.46875 -1.625 0.46875q-1.28125 0 -2.09375 -0.828125q-0.796875 -0.828125 -0.796875 -2.046875q0 -0.515625 0.328125 -1.28125l16.3125 -38.531254q0.515625 -1.140625 1.4375 -1.875q0.9375 -0.734375 2.28125 -0.734375l0.640625 0q1.34375 0 2.265625 0.734375q0.9375 0.734375 1.453125 1.875l16.3125 38.531254zm-20.34375 -33.718754l-8.640625 20.796879l17.265625 0l-8.625 -20.796879zm38.514175 38.20313q-3.515625 0 -6.109375 -1.65625q-2.59375 -1.671875 -3.96875 -4.546875q-1.375 -2.890625 -1.375 -6.34375l0 -18.171879q0 -1.21875 0.859375 -2.046875q0.875 -0.828125 2.09375 -0.828125q1.203125 0 2.03125 0.828125q0.84375 0.828125 0.84375 2.046875l0 17.531254q0 7.8125 7.03125 7.8125q3.203125 0 5.734375 -1.65625q2.53125 -1.671875 4.765625 -4.484375l0 -19.203129q0 -1.21875 0.859375 -2.046875q0.875 -0.828125 2.09375 -0.828125q1.203125 0 2.03125 0.828125q0.84375 0.828125 0.84375 2.046875l0 27.453129q0 1.21875 -0.84375 2.078125q-0.828125 0.859375 -2.03125 0.859375q-1.21875 0 -2.09375 -0.859375q-0.859375 -0.859375 -0.859375 -2.078125l0 -2.625q-2.421875 2.6875 -5.25 4.296875q-2.8125 1.59375 -6.65625 1.59375zm52.102432 -7.875q0.953125 0 1.6875 0.8125q0.75 0.796875 0.75 1.75q0 1.40625 -1.28125 2.234375q-2.109375 1.34375 -4.578125 2.21875q-2.46875 0.859375 -5.859375 0.859375q-4.609375 0 -8.515625 -2.046875q-3.90625 -2.046875 -6.25 -5.890625q-2.328125 -3.84375 -2.328125 -9.015625q0 -5.187504 2.328125 -9.031254q2.34375 -3.84375 6.25 -5.890625q3.90625 -2.046875 8.515625 -2.046875q3.390625 0 5.859375 0.875q2.46875 0.859375 4.578125 2.203125q1.28125 0.828125 1.28125 2.234375q0 0.953125 -0.75 1.765625q-0.734375 0.796875 -1.6875 0.796875q-0.703125 0 -1.40625 -0.390625q-2.109375 -1.078125 -3.625 -1.5625q-1.5 -0.484375 -3.734375 -0.484375q-5.5 0 -8.640625 3.171875q-3.140625 3.171875 -3.140625 8.359379q0 5.171875 3.140625 8.34375q3.140625 3.171875 8.640625 3.171875q2.234375 0 3.734375 -0.484375q1.515625 -0.484375 3.625 -1.5625q0.703125 -0.390625 1.40625 -0.390625zm27.77269 -26.046879q3.515625 0 6.109375 1.671875q2.59375 1.65625 3.96875 4.546875q1.375 2.875 1.375 6.328125l0 18.171879q0 1.21875 -0.859375 2.046875q-0.859375 0.828125 -2.078125 0.828125q-1.21875 0 -2.046875 -0.828125q-0.828125 -0.828125 -0.828125 -2.046875l0 -17.531254q0 -7.8125 -7.046875 -7.8125q-3.203125 0 -5.734375 1.671875q-2.515625 1.65625 -4.765625 4.46875l0 19.203129q0 1.21875 -0.859375 2.046875q-0.859375 0.828125 -2.078125 0.828125q-1.21875 0 -2.046875 -0.828125q-0.828125 -0.828125 -0.828125 -2.046875l0 -41.531254q0 -1.21875 0.828125 -2.078125q0.828125 -0.875 2.046875 -0.875q1.21875 0 2.078125 0.875q0.859375 0.859375 0.859375 2.078125l0 16.703125q2.4375 -2.6875 5.25 -4.28125q2.8125 -1.609375 6.65625 -1.609375zm27.913437 -9.28125q0 1.34375 -0.96875 2.3125q-0.953125 0.953125 -2.296875 0.953125l-0.390625 0q-1.34375 0 -2.3125 -0.953125q-0.953125 -0.96875 -0.953125 -2.3125l0 -0.25q0 -1.34375 0.953125 -2.296875q0.96875 -0.96875 2.3125 -0.96875l0.390625 0q1.34375 0 2.296875 0.96875q0.96875 0.953125 0.96875 2.296875l0 0.25zm-3.53125 9.609375q1.28125 0 2.109375 0.828125q0.84375 0.828125 0.84375 2.109375l0 27.453129q0 1.21875 -0.875 2.046875q-0.859375 0.828125 -2.078125 0.828125q-1.21875 0 -2.046875 -0.828125q-0.828125 -0.828125 -0.828125 -2.046875l0 -27.453129q0 -1.21875 0.828125 -2.078125q0.828125 -0.859375 2.046875 -0.859375zm31.041718 -0.328125q3.515625 0 6.109375 1.671875q2.59375 1.65625 3.96875 4.546875q1.375 2.875 1.375 6.328125l0 18.171879q0 1.21875 -0.859375 2.046875q-0.859375 0.828125 -2.078125 0.828125q-1.21875 0 -2.046875 -0.828125q-0.828125 -0.828125 -0.828125 -2.046875l0 -17.531254q0 -7.8125 -7.046875 -7.8125q-3.203125 0 -5.734375 1.671875q-2.515625 1.65625 -4.765625 4.46875l0 19.203129q0 1.21875 -0.859375 2.046875q-0.859375 0.828125 -2.078125 0.828125q-1.21875 0 -2.046875 -0.828125q-0.828125 -0.828125 -0.828125 -2.046875l0 -27.453129q0 -1.21875 0.828125 -2.078125q0.828125 -0.859375 2.046875 -0.859375q1.21875 0 2.078125 0.859375q0.859375 0.859375 0.859375 2.078125l0 2.625q2.4375 -2.6875 5.25 -4.28125q2.8125 -1.609375 6.65625 -1.609375zm34.757187 0q6.265625 0 10.9375 4.859375l0 -15.671875q0 -1.28125 0.859375 -2.109375q0.875 -0.84375 2.09375 -0.84375q1.203125 0 2.03125 0.875q0.84373474 0.859375 0.84373474 2.078125l0 41.531254q0 1.21875 -0.84373474 2.046875q-0.828125 0.828125 -2.03125 0.828125q-1.21875 0 -2.09375 -0.828125q-0.859375 -0.828125 -0.859375 -2.046875l0 -1.65625q-4.671875 4.859375 -10.9375 4.859375q-3.96875 0 -7.53125 -2.015625q-3.546875 -2.015625 -5.75 -5.890625q-2.203125 -3.875 -2.203125 -9.046875q0 -5.187504 2.203125 -9.062504q2.203125 -3.875 5.75 -5.890625q3.5625 -2.015625 7.53125 -2.015625zm0.828125 28.484379q2.953125 0 5.53125 -1.3125q2.59375 -1.3125 4.578125 -3.484375l0 -13.453129q-1.984375 -2.171875 -4.578125 -3.484375q-2.578125 -1.3125 -5.53125 -1.3125q-4.734375 0 -7.625 3.015625q-2.875 3.0 -2.875 8.515629q0 5.5 2.875 8.515625q2.890625 3.0 7.625 3.0zm40.446426 -28.484379q4.859375 0 8.578125 2.109375q3.71875 2.109375 5.765625 5.984375q2.046875 3.875 2.046875 8.875004q0 4.984375 -2.046875 8.859375q-2.046875 3.875 -5.765625 5.984375q-3.71875 2.109375 -8.578125 2.109375q-4.921875 0 -8.640625 -2.109375q-3.703125 -2.109375 -5.71875 -5.984375q-2.015625 -3.875 -2.015625 -8.859375q0 -5.000004 2.015625 -8.875004q2.015625 -3.875 5.71875 -5.984375q3.71875 -2.109375 8.640625 -2.109375zm0 28.609379q2.625 0 5.015625 -1.21875q2.40625 -1.21875 3.96875 -3.84375q1.578125 -2.625 1.578125 -6.65625q0 -3.9687538 -1.578125 -6.578129q-1.5625 -2.625 -3.96875 -3.8125q-2.390625 -1.1875 -5.015625 -1.1875q-2.6875 0 -5.09375 1.1875q-2.390625 1.1875 -3.9375 3.8125q-1.53125 2.609375 -1.53125 6.578129q0 4.03125 1.53125 6.65625q1.546875 2.625 3.9375 3.84375q2.40625 1.21875 5.09375 1.21875zm65.28696 -28.281254q1.21875 0 2.046875 0.828125q0.828125 0.828125 0.828125 2.046875q0 0.515625 -0.1875 1.09375l-9.09375 26.609379q-0.375 1.15625 -1.40625 1.921875q-1.03125 0.765625 -2.296875 0.765625q-1.28125 0 -2.3125 -0.765625q-1.015625 -0.765625 -1.46875 -1.984375l-6.78125 -21.171879l-6.78125 21.171879q-0.453125 1.21875 -1.484375 1.984375q-1.015625 0.765625 -2.296875 0.765625q-1.28125 0 -2.3125 -0.765625q-1.015625 -0.765625 -1.40625 -1.921875l-9.078125 -26.609379q-0.203125 -0.578125 -0.203125 -1.09375q0 -1.21875 0.828125 -2.046875q0.84375 -0.828125 2.0625 -0.828125q0.890625 0 1.625 0.484375q0.734375 0.46875 1.0 1.234375l7.484375 24.640629l7.421875 -24.062504q0.328125 -1.03125 1.1875 -1.65625q0.859375 -0.640625 1.953125 -0.640625q1.078125 0 1.9375 0.640625q0.875 0.625 1.1875 1.65625l7.4375 24.062504l7.484375 -24.640629q0.25 -0.765625 0.984375 -1.234375q0.734375 -0.484375 1.640625 -0.484375zm27.193054 -0.328125q3.515625 0 6.109375 1.671875q2.59375 1.65625 3.96875 4.546875q1.375 2.875 1.375 6.328125l0 18.171879q0 1.21875 -0.859375 2.046875q-0.859375 0.828125 -2.078125 0.828125q-1.21875 0 -2.046875 -0.828125q-0.828125 -0.828125 -0.828125 -2.046875l0 -17.531254q0 -7.8125 -7.046875 -7.8125q-3.203125 0 -5.734375 1.671875q-2.515625 1.65625 -4.765625 4.46875l0 19.203129q0 1.21875 -0.859375 2.046875q-0.859375 0.828125 -2.078125 0.828125q-1.21875 0 -2.046875 -0.828125q-0.828125 -0.828125 -0.828125 -2.046875l0 -27.453129q0 -1.21875 0.828125 -2.078125q0.828125 -0.859375 2.046875 -0.859375q1.21875 0 2.078125 0.859375q0.859375 0.859375 0.859375 2.078125l0 2.625q2.4375 -2.6875 5.25 -4.28125q2.8125 -1.609375 6.65625 -1.609375z"
					fill-rule="nonzero"
				/>
				<path
					transition:fly|local
					fill="RGB(51,51,51)"
					fill-opacity="0.0"
					d="m167.00787 40.03937l54.146545 0l0 51.68504l167.23929 0"
					fill-rule="nonzero"
				/>
				<path
					transition:draw|local
					class="dashes"
					stroke="RGB(51,51,51)"
					stroke-width="3.0"
					stroke-linejoin="round"
					stroke-linecap="butt"
					stroke-dasharray="24.0,6.0"
					d="m178.37787 40.03937l42.77655 0l0 51.68504l155.8693 0"
					fill-rule="evenodd"
				/>
				<path
					transition:fly|local={{ y: 200 }}
					id="circle"
					fill="RGB(51,51,51)"
					stroke="RGB(51,51,51)"
					stroke-width="3.0"
					stroke-linecap="butt"
					d="m168.50787 40.03937c0 -2.725525 2.2094727 -4.9350014 4.9349976 -4.9350014c2.725525 0 4.9349976 2.2094765 4.9349976 4.9350014c0 2.725525 -2.2094727 4.9349976 -4.9349976 4.9349976c-2.725525 0 -4.9349976 -2.2094727 -4.9349976 -4.9349976z"
					fill-rule="nonzero"
				/>
				<path
					transition:fly|local={{ x: 200 }}
					id="square"
					stroke="RGB(51,51,51)"
					stroke-width="3.0"
					stroke-linecap="butt"
					d="m377.0237 86.78941l9.869995 0l0 9.869995l-9.869995 0l0 -9.869995z"
					fill-rule="nonzero"
				/>
			{/if}
			{#if usage === "wait"}
				<path
					class="path-colour"
					transition:draw|local
					id="dashes"
					stroke-width="3.0"
					stroke-linejoin="round"
					stroke-linecap="butt"
					stroke-dasharray="24.0,9.0"
					d="m180.84244 39.83202l26.283554 0l0 51.33858l26.283539 0"
					fill-rule="evenodd"
				/>
				<path
					class="path-colour"
					transition:fly|local={{ y: 200 }}
					id="circle"
					fill="RGB(51,51,51)"
					stroke-width="3.0"
					stroke-linecap="butt"
					d="m170.97244 39.83202c0 -2.725525 2.2094727 -4.9349976 4.9349976 -4.9349976c2.725525 0 4.9349976 2.2094727 4.9349976 4.9349976c0 2.725525 -2.2094727 4.9350014 -4.9349976 4.9350014c-2.725525 0 -4.9349976 -2.2094765 -4.9349976 -4.9350014z"
					fill-rule="nonzero"
				/>
				<path
					class="path-colour"
					transition:fly|local={{ y: -200 }}
					id="square"
					stroke-width="3.0"
					stroke-linecap="butt"
					d="m233.40953 86.2356l9.869995 0l0 9.870003l-9.869995 0l0 -9.870003z"
					fill-rule="nonzero"
				/>
			{/if}
		</g>
	</svg>
</div>

<style>
	/*
  @media (prefers-color-scheme: dark) {
    .path-colour {
      stroke: RGB(204, 204, 204);
    }
  }

  @media (prefers-color-scheme: light) {
    .path-colour {
      stroke: RGB(51, 51, 51);
    }
  }
  */

	.path-colour {
		stroke: rgb(51, 51, 51);
	}

	#centre {
		width: 100%;
		z-index: 90000;
		position: fixed;
		left: 0px;
		right: 0px;
	}

	#logo {
		width: 100%;
	}

	#side {
		width: 120px;
		position: fixed;
		bottom: 75px;
		z-index: 90000;
		transition: transform 0.25s ease;
		animation: 1s ease;
	}

	#side.left {
		transform: rotate(90deg) translateY(100%) translateX(-25%);
		left: 0px;
	}

	#side.right {
		transform: rotate(270deg) translateY(100%);
		right: 0px;
	}

	#wait {
		width: 100%;
		/* position: absolute; */
	}

	#dashes {
		animation-name: dashAnimation;
		animation-duration: 20s;
		animation-iteration-count: infinite;
		animation-timing-function: linear;
		animation-direction: alternate;
	}

	@keyframes dashAnimation {
		from {
			stroke-dasharray: 10, 5;
			stroke-dashoffset: 10;
		}
		to {
			stroke-dasharray: 10, 5;
			stroke-dashoffset: 510;
		}
	}

	@media only screen and (max-width: 475px) {
		#side.left {
			transform: rotate(90deg) translateY(120%) translateX(10%) scale(0.75); 
			left: 0svw;
		}
	}
</style>
